import { createFileRoute } from "@tanstack/react-router";

import { MeetingSetupPage } from "../features/premeeting/components/MeetingSetupPage.tsx";

export const Route = createFileRoute("/_app/meetings/$id/setup")({
  component: PreMeetingPage,
});

function PreMeetingPage() {
  const { id } = Route.useParams();
  return <MeetingSetupPage meetingId={id} />;
}
